import { FilterItem } from "@/types/filters";
import useAuth from "@hooks/useAuth";
import {
  removeFav,
  selectFavFilters,
} from "@redux/slices/favourite";
import { ChevronLeft, Star, X } from "lucide-react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import SimpleBar from "simplebar-react";


const Favourites = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const favFilters = useSelector(selectFavFilters);
  const {user}=useAuth();

  const handleToggleFav = (val: FilterItem, index: number) => {
    const existingIndex = favFilters.findIndex(
      (fav) => fav.index === index && fav.path === val.path
    );
    console.log(existingIndex);
    dispatch(
      removeFav({
        title: val.title,
        description: val.description,
        path: val.path,
        index,
      })
    );
  };

  const isFav = (path: string): boolean => {
    const fav = favFilters.some((fav) => fav.path === path);
    return fav;
  };

  console.log(favFilters);
  return (
    <div className="w-2/3">
      <SimpleBar style={{ maxHeight: 450 }}>
        <div className="flex flex-wrap">
          {favFilters?.map((val: FilterItem, index: number) => (
            <div className="w-1/3">
            <div
              key={index}
              className="bg-white flex justify-center items-center text-center m-2 mt-0 px-4 flex-col h-56 rounded-lg cursor-pointer relative"
              onClick={() => navigate(`/targetMarkets/${user?.role}/?filter=${val.path}`)}
            >
              {/* <Star
                className={`absolute top-5 right-5 cursor-pointer ${
                  isFav(val.path) ? "fill-current text-yellow-500" : ""
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleToggleFav(val, index);
                }}
              /> */}
              <h6 className="text-gray text-lg font-medium pt-2 pb-3">
                {val.title}
              </h6>
              <p className="text-[#71717A] text-sm">{val.description}</p>
            </div>
            </div>
          ))}
        </div>
      </SimpleBar>
    </div>
  );
};

export default Favourites;
